export default "https://cdn-static.gokick.com/assets/9d5d62c9c10b295872f7f6ffd14ff177054c61a9/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";